"use client";
import { FeedPostFooter } from "../FeedPostFooter";
import { FeedPostDtoWithOgMetadata } from "@/api/posts/types";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { FeedPostCommentsList } from "../../Comments/CommentsList/FeedPost";
import { FeedPostContent } from "../FeedPostContent";
import { NewsFeedPostContent } from "../NewsFeed/NewsFeedPostContent";

export interface Props {
  feedPost: FeedPostDtoWithOgMetadata;
  hideActions?: boolean;
  className?: string;
  hideCommentList?: boolean;
}

export default function FeedPost({
  feedPost,
  className,
  hideActions = false,
  hideCommentList = false,
}: Props) {
  const [showReply, setShowReply] = useState(false);

  return (
    <li
      className={twMerge(
        "pb-4 md:pb-6 border-b border-opacityGray-300 list-none last-of-type:border-b-0",
        className,
      )}
    >
      {feedPost.portalMetadata ? (
        <NewsFeedPostContent feedPost={feedPost} />
      ) : (
        <FeedPostContent feedPost={feedPost} hideActions={hideActions} />
      )}

      {!hideActions && (
        <FeedPostFooter feedPost={feedPost} setShowReply={setShowReply} />
      )}

      {!hideCommentList && (
        <FeedPostCommentsList
          feedPost={feedPost}
          showReply={showReply}
          setShowReply={setShowReply}
        />
      )}
    </li>
  );
}
